import { PlatformLocation } from '@angular/common';
import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ModalBaseEscComponent } from '../shared/component/modal-base-esc.component';

@Component({
  selector: 'cc-add-tag-group',
  templateUrl: 'add-tag-group.component.html',
  styleUrls: ['add-tag-group.component.scss'],
})
export class AddTagGroupComponent extends ModalBaseEscComponent implements OnInit {
  @ViewChild('newItemRef')
  newItemRef: ElementRef;

  newItem = { value: '', invalid: false };
  selectedItems = [];
  submitted;
  title;
  model;
  isForAdd;

  constructor(public modal: NgbActiveModal, private location: PlatformLocation) {
    super(location, modal);
  }

  ngOnInit(): void {
    if (this.isForAdd) {
      this.model = { name: '', items: [] };
    } else {
      this.model.items = this.model.tags.map((tag, index) => {
        return { id: index, value: tag };
      });
    }
  }

  save() {
    this.submitted = true;
    if (this.model.name && this.model.items.length > 0) {
      this.closeModal(this.model);
    }
  }

  addItem() {
    if (this.newItem.value) {
      if (!/^[A-Za-z0-9-_\s]+$/.test(this.newItem.value) || this.newItem.value.trim() === '') {
        this.newItem.invalid = true;
      } else {
        this.model.items.push({ id: this.model.items.length + 1, value: this.newItem.value });
        this.newItem = { value: '', invalid: false };
        this.newItemRef.nativeElement.focus();
      }
    }
  }

  removeItem() {
    this.model.items = this.model.items.filter((i) => !this.selectedItems.includes(i.id));
    this.selectedItems = [];
  }
}
